import React, { useEffect, useMemo, useRef, useState } from 'react';
import ReactTabulator from './ReactTabulator';
import CheckList from './components/CheckList/CheckList';
import GroupBy from './components/GroupBy/GroupBy';
import HideColumns from './components/HideColumns/HideColumns';
import ExportComponent from './components/ExportComponent/ExportComponent';
import SelectRowColumn from './components/SelectRowColumn/selectRowColumn1';
import styles from './style/tabulator.module.css';
import { handleSetPaging } from './functions/handleSetPaging';
import { handleSetFilter } from './functions/handleSetFilter';
import { handleSetSorters } from './functions/handleSetSorters';
import { handleSetPageSize } from './functions/handleSetPageSize';
import { Tooltip } from '@mui/material';
import './tabulator.css';

// tabulator grid
const TabGrid = ({
  data = [],
  columns,
  height = '70vh',
  setGridFilter,
  gridFilter,
  pageSize = 25,
  selectable = false,
  getSelectedRows,
  getSelectedRow,
  multiRow,
  rowClick,
  clickedRow,
  notSelect,
  loading,
  selectedRows,
  columnVisibility,
  setColumnVisibility,
  showHeader = true,
  getRowColor,
  hideFooter = false,
  comfort = false, // naknadno dodato
  onRowEdit, // dodato
}) => {
  const tableRef = useRef(null);
  // const memoData = useMemo(() => data.map((item) => ({ ...item })), [data]);  ovo je bilo u prethodnoj verziji pa je dodat state i u useefectu je dodat kao zavisnost
  const [memoData, setMemoData] = useState([]);
  const [isGridReady, setIsGridReady] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setMemoData(data.map((item) => ({ ...item })));
    }, 0);
  }, [data]);

  useEffect(() => {
    if (selectedRows !== undefined && selectedRows.length >= 0 && !selectable) {
      setTimeout(() => {
        setMemoData(data.map((item) => ({ ...item })));
      }, 0);
    }
  }, [selectedRows]);

  const saveTableState = () => {
    const table = tableRef.current;
    if (table && isGridReady) {
      const filters = table.getHeaderFilters();
      let sorters = [];
      if (table.getSorters) {
        sorters = table.getSorters();
      }

      const page = table.getPage();
      const pageSize = table.getPageSize();

      const sortObj = sorters?.length > 0 ? sorters[0] : {};

      // const tableState = {
      //   filters,
      //   sorters,
      //   page,
      //   pageSize,
      // };

      setGridFilter({
        filters,
        sorters: [{ field: sortObj.field, dir: sortObj.dir }],
        page,
        pageSize,
      });

      // console.log('==== tableState ====', tableState);
    }
  };
  // useEffect(() => {
  //   return () => {
  //     saveTableState();
  //   };
  // }, []);

  const handleClickedRow = () => {
    const table = tableRef.current;
    const selectedRow = table.searchRows('id', '=', clickedRow.id);
    if (selectedRow.length > 0) {
      selectedRow[0].getElement().classList.add(styles.selectedRow);

      // ✅ Simuliraj klik na red
      // selectedRow[0]
      //   .getElement()
      //   .dispatchEvent(new Event('click', { bubbles: true }));
    }
  };
  // prijavljivanje na eventove grida
  // Nalazi se u useEffect da bi uvek bili prijavljeni
  useEffect(() => {
    if (tableRef.current) {
      console.clear();
      //     // Ukloni stare event listenere
      const table = tableRef.current;
      // ✅ Ukloni stare event listenere da se ne dupliraju
      table.off('dataFiltering');
      table.on('dataFiltering', (filters) => {
        // console.log('==== FILTER EVENT ====');
        setTimeout(saveTableState, 200);
        // saveTableState();
      });
      table.off('dataSorted');
      table.on('dataSorted', (sorters, rows) => {
        // console.log('==== SORT EVENT ====');
        setTimeout(saveTableState, 200);
        // saveTableState();
      });
      table.off('cellEdited');
      table.on('cellEdited', (cell) => {
        const updatedRow = cell.getRow().getData();
        const field = cell.getField();
        const newValue = cell.getValue();

        if (typeof onRowEdit === 'function') {
          onRowEdit(updatedRow, field, newValue);
        }
      });
      table.off('pageLoaded');
      table.on('pageLoaded', (sorters, rows) => {
        // console.log('==== PAGING EVENT ====');
        setTimeout(saveTableState, 200);
        // saveTableState();
      });
      table.off('pagesize');
      table.on('pagesize', (sorters, rows) => {
        // console.log('==== PAGE SIZE EVENT ====');
        setTimeout(saveTableState, 200);
        // saveTableState();
      });
      table.off('rowClick');
      table.on('rowClick', (e, row) => {
        const clickedCell = e.target.closest('.tabulator-cell'); // Pronađi ćeliju koja je kliknuta
        const columnField = clickedCell?.getAttribute('tabulator-field'); // Dobij naziv kolone
        if (columnField === 'id') {
          e.stopPropagation(); // Sprečava dalje širenje eventa
          return; // Prekidamo izvršenje funkcije
        }
        // ✅ Pronađi trenutno selektovani red (ako postoji) i ukloni klasu
        const tabulatorElement = e.target.closest('.tabulator');
        const selectedRow = tabulatorElement.querySelector(
          `.${styles.selectedRow}`,
        );
        if (selectedRow) {
          selectedRow.classList.remove(styles.selectedRow);

          // Ako korisnik ponovo klikne na isti red, deselektuj ga i prekini izvršenje
          // if (selectedRow === row.getElement()) {
          //   return;
          // }
        }

        // ✅ Dodaj klasu samo na kliknut red
        row.getElement().classList.add(styles.selectedRow);
        rowClick(row.getData());
        // console.log('==== KLIK NA RED====', row.getData());
      });
      table.off('tableBuilt');
      table.on('tableBuilt', () => {
        // console.log('==== BUILD GRIDA ====', {
        //   filter: gridFilter?.filters,
        //   sorters: gridFilter?.sorters,
        // });
        setTimeout(() => {
          setIsGridReady(true);
        }, 0);

        if (gridFilter) {
          if (gridFilter?.sorters) {
            handleSetSorters(gridFilter?.sorters, table);
          }
          if (gridFilter?.filters) {
            handleSetFilter(gridFilter?.filters, table);
          }
          if (gridFilter?.page) {
            handleSetPaging(gridFilter?.page, table);
          }
          if (gridFilter?.pageSize) {
            handleSetPageSize(gridFilter?.pageSize, gridFilter?.page, table);
          }
        }
        if (clickedRow) {
          handleClickedRow();
        }
      });
      //     // Dodavanje custom listener-a za sortiranje na zaglavlja kolona
    } else {
      console.error('❌ Tabulator instanca nije inicijalizovana.');
    }
  }, [tableRef.current, memoData]);
  // Custom Header Filter
  const CustomHeaderFilter = (cell, onRendered, success, cancel) => {
    const fieldType = cell.getColumn().getDefinition().type; // Preuzimanje tipa kolone
    let filterElement;

    if (fieldType === 'boolean') {
      // Kreiraj select za boolean vrednosti
      filterElement = document.createElement('select');
      filterElement.style.width = '100%';
      filterElement.style.boxSizing = 'border-box';

      const options = [
        { value: '', label: 'Svi' },
        { value: 'true', label: 'Aktivan' },
        { value: 'false', label: 'Neaktivan' },
      ];
      options.forEach((option) => {
        const opt = document.createElement('option');

        opt.value = option.value;
        opt.text = option.label;
        filterElement.appendChild(opt);
      });

      filterElement.addEventListener('change', () => {
        // console.log(
        //   'Promena u boolean filteru za kolonu:',
        //   cell.getField(),
        //   filterElement.value,
        // );
        success(
          filterElement.value === '' ? null : filterElement.value === 'true',
        ); // Apply the filter
      });
    } else {
      // Kreiraj input za tekstualne vrednosti
      filterElement = document.createElement('input');
      filterElement.type = 'text';
      filterElement.style.width = '100%';
      filterElement.style.boxSizing = 'border-box';

      filterElement.addEventListener('change', () => {
        // setGridFilter((prevFilters) => {
        //   const fieldToUpdate = cell.getField();
        //   const newValue = filterElement.value;

        //   // Proveri da li već postoji filter sa istim field-om
        //   const existingFilterIndex = prevFilters.findIndex(
        //     (filter) => filter.field === fieldToUpdate,
        //   );

        //   if (existingFilterIndex !== -1) {
        //     // Ako postoji, zameni ga novim vrednostima
        //     return prevFilters.map((filter, index) =>
        //       index === existingFilterIndex
        //         ? { ...filter, value: newValue } // Ažuriraj postojeći
        //         : filter,
        //     );
        //   }
        //   // Ako ne postoji, dodaj novi
        //   return [
        //     ...prevFilters,
        //     { field: fieldToUpdate, type: 'like', value: newValue },
        //   ];
        // });
        // console.log(
        //   'Promena u tekstualnom filteru za kolonu:',
        //   cell.getField(),
        //   filterElement.value,
        // );
        success(filterElement.value); // Apply the filter
      });
    }

    // onRendered(() => {
    //   filterElement.focus(); // Fokusira input kada se renderuje
    // });

    return filterElement;
  };

  const booleanFormatter = (cell) => {
    return cell.getValue() ? '✔' : '✖';
  };
  // prilagodjavanje kolona za tabulator
  const _columns = useMemo(() => {
    const mapiraneKolone = columns.map((item) => {
      return {
        ...item,
        // minWidth: item.width,
        title: item.headerName,
        renderCell: item.renderCell,
        valueFormatter: item.valueFormatter,
        headerFilter: item.filterable !== false ? CustomHeaderFilter : null,
        resizable: true,
        formatter: item.type === 'boolean' ? booleanFormatter : item.formatter,
        hozAlign: item.type === 'boolean' ? 'center' : item.hozAlign,
        frozen: item.frozen || false,
      };
    });
    if (selectable) {
      const handleSelect = (id, checked) => {
        if (checked) {
          tableRef.current.selectRow(id);
          getSelectedRow(id);
        } else {
          tableRef.current.deselectRow(id);
        }
        getSelectedRows(tableRef.current.getSelectedData());
      };
      console.log(selectedRows);
      const selectColumn = {
        field: 'id',
        disableExport: true,
        headerName: '',
        width: 50,
        sortable: false,
        filterable: false,
        frozen: true,
        renderCell: ({ row, value }) => {
          if (notSelect && row) {
            // Pronalazimo da li red treba biti onemogućen
            const exclusion = notSelect.find(
              (item) => row[item.columns] === item.value,
            );

            if (exclusion) {
              return (
                <div>
                  {exclusion.tooltip !== '' ? (
                    <Tooltip
                      title={<h3>{exclusion.tooltip}</h3>}
                      placement="top"
                      PopperProps={{
                        modifiers: [
                          {
                            name: 'preventOverflow',
                            options: {
                              boundary: 'viewport',
                            },
                          },
                        ],
                      }}
                    >
                      <div
                        style={{ display: 'flex', justifyContent: 'center' }}
                      >
                        <input
                          type="checkbox"
                          disabled
                          style={{
                            transform: 'scale(1.4)',
                            margin: '5px',
                            cursor: 'not-allowed',
                          }}
                        />
                      </div>
                    </Tooltip>
                  ) : (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <input
                        type="checkbox"
                        disabled
                        style={{
                          transform: 'scale(1.4)',
                          margin: '5px',
                          cursor: 'not-allowed',
                        }}
                      />
                    </div>
                  )}
                </div>
              );
            }
          }
          return (
            <SelectRowColumn
              value={value}
              handleSelect={handleSelect}
              selectedRows={selectedRows}
              memoData={memoData}
            />
          );
        },

        cellClick: (e, cell) => {
          // console.log('Kliknuta ćelija:', cell.getData());
          if (col.preventRowClick) {
            e.stopPropagation(); // Sprečava aktiviranje `rowClick`
          }
        },
        title: '',
      };
      mapiraneKolone.unshift(selectColumn);
    }
    // console.log('=== mapirane kolone====', mapiraneKolone);
    return mapiraneKolone;
  }, [columns]);

  // grupisanje kolona
  const handleGroupBy = (column) => {
    if (tableRef.current) {
      tableRef.current.setGroupBy(column);
      // console.log(`Grouped by ${column}`);
    }
  };

  // ciscenje svih filtera
  const handleClearFilters = () => {
    if (tableRef.current) {
      tableRef.current.clearFilter(true); // Uklanja sve filtere, uključujući header filtere
      setGridFilter({});
      // console.log('Svi filteri su obrisani.');

      // ✅ Dobavi sve kolone
      // const columns = tableRef.current.getColumns();

      // // ✅ Pronađi prvu kolonu koja ima filter
      // const firstFilteredColumn = columns.find(
      //   (col) => col.getDefinition().headerFilter,
      // );

      // if (firstFilteredColumn) {
      //   // ✅ Pronađi filter input/select u headeru
      //   const firstFilter = firstFilteredColumn
      //     .getElement()
      //     .querySelector('input, select');

      //   if (firstFilter) {
      //     firstFilter.focus(); // ✅ Postavi fokus na input prve filtrirane kolone
      //   }
      // }
    }
  };
  const rowFormatter = (row) => {
    const rowData = row.getData();
    if (getRowColor) {
      const color = getRowColor(rowData);
      if (color) {
        row.getElement().style.backgroundColor = color;
        // row.getElement().style.color = 'white'; // Bele boje slova za kontrast
      }
    }
  };

  return (
    <div
      style={{ position: 'relative', border: '1px solid #303030' }}
      className={hideFooter ? 'hide-footer' : ''}
    >
      {loading && (
        <div className={styles.loaderWrapper}>
          <div className={styles.loader} />
        </div>
      )}
      {showHeader && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '5px',
            marginBottom: '0px',
          }}
        >
          <HideColumns
            columns={_columns}
            tableRef={tableRef}
            columnVisibility={columnVisibility}
            setColumnVisibility={setColumnVisibility}
          />
          <GroupBy columns={_columns} handleGroupBy={handleGroupBy} />
          <ExportComponent tableRef={tableRef} />
          <button onClick={handleClearFilters} style={{ color: '#3498db' }}>
            OBRIŠI FILTERE
          </button>
          {/* <button onClick={handleSetFilter}>DODAJ FILTER</button> */}
        </div>
      )}
      <ReactTabulator
        comfort={comfort}
        ref={tableRef}
        columns={_columns}
        data={memoData}
        options={{
          height: height,
          layout: 'fitColumns',
          pagination: 'local',
          paginationSize: pageSize,
          paginationSizeSelector: [10, 25, 50, 100, 1000, true],
          groupHeader: (value, count) => `${value} (${count} items)`,
          groupToggleElement: 'header',
          movableColumns: true, // Enable column reordering
          resizableColumns: true, // Enable column resizing
          virtualDom: false, // Virtual DOM for performance   -  bilo true
          virtualDomBuffer: 0, // bilo 10, pa izmenjeno na 0
          groupStartOpen: false,
          headerFilterLiveFilter: true,
          paginationCounter: 'rows',
          rowFormatter: rowFormatter,
        }}
      />
    </div>
  );
};

export default TabGrid;
